(function () {
  'use strict';

  if (window.KgTakeover) {
    window.KgTakeover.init(document);
    return;
  }

  var variants = ['office', 'upside-down', 'juggling', 'full-send'];
  var memory = {};

  function readState(key) {
    for (var i = 0; i < 2; i += 1) {
      try {
        var storage = i === 0 ? window.localStorage : window.sessionStorage;
        var value = JSON.parse(storage.getItem(key));
        if (value && typeof value === 'object' && !Array.isArray(value)) return value;
      } catch (error) {}
    }
    return memory[key] || {};
  }

  function writeState(key, value) {
    memory[key] = value;
    for (var i = 0; i < 2; i += 1) {
      try {
        var storage = i === 0 ? window.localStorage : window.sessionStorage;
        storage.setItem(key, JSON.stringify(value));
      } catch (error) {}
    }
  }

  function token() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes).map(function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    }
    return (Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).padEnd(32, '0');
  }

  function randomVariant() {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return variants[values[0] % variants.length];
    }
    return variants[Math.floor(Math.random() * variants.length)];
  }

  function initialize(root) {
    if (root.dataset.kgInitialized) return;
    root.dataset.kgInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var tab = document.getElementById('KgTakeoverTab-' + sectionId);
    var form = root.querySelector('.kg-takeover__form');
    if (!form) return;
    var email = form.querySelector('.kg-takeover__email');
    var submit = form.querySelector('.kg-takeover__submit');
    var errorEl = form.querySelector('.kg-takeover__error');
    var statusEl = form.querySelector('.kg-takeover__status');
    var challengeButton = form.querySelector('.kg-takeover__challenge');
    var tagsInput = form.querySelector('[data-kg-tags]');
    var resultMarker = form.querySelector('[data-kg-form-result]');
    var cta = root.querySelector('.kg-takeover__cta');
    var image = root.querySelector('.kg-takeover__media img');
    var defaultCta = { href: cta.getAttribute('href'), label: cta.textContent };
    var steps = root.querySelectorAll('[data-step]');
    var params = new URLSearchParams(window.location.search);
    var challengePage = /^\/challenge(?:\/|$)/.test(window.location.pathname);
    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    var preview = root.dataset.previewOnly !== 'false' || params.has('kg_popup_preview') ||
      params.has('preview_theme_id') || designMode || Boolean(window.Shopify && window.Shopify.theme &&
      window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
    var experimentEnabled = root.dataset.experimentEnabled === 'true';
    var experimentId = root.dataset.experimentId || 'circle-popup-25-v1';
    var stateKey = 'kg-takeover:' + (experimentEnabled ? experimentId : 'default');
    var pendingKey = stateKey + ':pending:' + sectionId;
    var enrolled = !preview && analyticsAllowed();
    var state = preview ? {} : enrolled ? readState(stateKey) : memory[stateKey] || {};
    var legacy = preview ? {} : readState('kg-takeover');
    var forced = params.get('kg_popup_preview');
    var variant = preview ? (variants.indexOf(forced) >= 0 ? forced : 'office') :
      (experimentEnabled ? (variants.indexOf(state.variant) >= 0 ? state.variant : randomVariant()) : 'office');
    var choice = '';
    var busy = false;
    var completed = !preview && Boolean(state.done || legacy.done);
    var previousFocus;
    var previousOverflow;
    var pendingRequest;
    var attemptRecorded = false;
    var healthEndpoint = 'https://os.alwaysunhinged.com/api/popup-health';
    var healthQueueKey = 'kg-popup-health-queue';
    var healthSending = {};
    var healthQueueMemory = [];
    var submissionVariant;
    var suppressSignupMeasurement = false;
    var recoveredSubmission = null;
    var timer;
    var controller;
    var listenerController = new AbortController();
    var listenerOptions = { signal: listenerController.signal };
    var originalSubmitLabel = submit.textContent;
    var publishing = false;
    var retryTimer;
    var retryCount = 0;
    var privacyTimer;
    var privacyAttempts = 0;
    var privacyFeatureRequested = false;
    var officeImage = image ? { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), sizes: image.getAttribute('sizes') } : null;
    var frequency = Math.max(1, Number(root.dataset.frequency) || 30) * 86400000;
    var delay = Math.max(0, Number(root.dataset.delay) || 0) * 1000;

    if (preview) {
      form.setAttribute('method', 'get');
      form.setAttribute('action', '#kg-popup-preview');
      form.removeAttribute('data-captcha');
      form.removeAttribute('data-shopify-captcha');
      Array.from(form.elements).forEach(function (field) { field.removeAttribute('name'); });
      submit.type = 'button';
    }

    function analyticsAllowed() {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
          privacy.analyticsProcessingAllowed() === true);
      } catch (error) { return false; }
    }

    function checkPrivacyReady() {
      if (preview || !experimentEnabled || listenerController.signal.aborted) return;
      window.clearTimeout(privacyTimer);
      var shopify = window.Shopify;
      if (shopify && shopify.customerPrivacy && typeof shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        if (root.hasAttribute('data-open') && !completed) expose();
        else retryMeasurements();
        return;
      }
      if (!privacyFeatureRequested && shopify && typeof shopify.loadFeatures === 'function') {
        privacyFeatureRequested = true;
        try {
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
            if (!error) checkPrivacyReady();
          });
        } catch (error) {}
      }
      if (privacyAttempts < 20) {
        privacyAttempts += 1;
        privacyTimer = window.setTimeout(checkPrivacyReady, 500);
      }
    }

    function applyVariant() {
      root.dataset.variant = variant;
      if (!image) return;
      if (variant === 'office') {
        image.src = officeImage.src;
        if (officeImage.srcset) image.setAttribute('srcset', officeImage.srcset);
        if (officeImage.sizes) image.setAttribute('sizes', officeImage.sizes);
      } else {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = root.getAttribute('data-image-' + variant);
      }
    }
    root.dataset.preview = String(preview);
    applyVariant();
    if (!preview) {
      state.variant = variant;
      memory[stateKey] = state;
      if (enrolled) {
        state.visitor = state.visitor || token();
        writeState(stateKey, state);
      }
    }

    function save(patch) {
      if (preview) return;
      Object.keys(patch).forEach(function (key) { state[key] = patch[key]; });
      memory[stateKey] = state;
      if (enrolled && analyticsAllowed()) writeState(stateKey, state);
    }

    function enroll() {
      if (preview || !experimentEnabled || !analyticsAllowed()) return false;
      if (!enrolled) {
        if (completed && !recoveredSubmission) return false;
        var prior = readState(stateKey);
        if (variants.indexOf(prior.variant) >= 0) {
          state = prior;
          variant = prior.variant;
          applyVariant();
        }
        enrolled = true;
        save({ variant: variant, visitor: state.visitor || token() });
      }
      return true;
    }

    function pending(value) {
      if (preview) return;
      try {
        if (value) window.sessionStorage.setItem(pendingKey, JSON.stringify(value));
        else window.sessionStorage.removeItem(pendingKey);
      } catch (error) {}
    }

    function healthQueue() {
      try { return JSON.parse(window.sessionStorage.getItem(healthQueueKey)) || healthQueueMemory; } catch (error) { return healthQueueMemory; }
    }

    function storeHealthQueue(queue) {
      healthQueueMemory = queue.slice(-30);
      try { window.sessionStorage.setItem(healthQueueKey, JSON.stringify(queue.slice(-30))); } catch (error) {}
    }

    function flushHealth() {
      if (preview || typeof window.fetch !== 'function') return;
      var queue = healthQueue().filter(function (item) { return Date.now() - item.time < 86400000; });
      storeHealthQueue(queue);
      queue.forEach(function (item) {
        var key = item.receipt.attemptId + ':' + item.receipt.stage;
        if (healthSending[key]) return;
        healthSending[key] = true;
        window.fetch(healthEndpoint, {
          method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(item.receipt), credentials: 'omit', keepalive: true,
          redirect: 'error', referrerPolicy: 'no-referrer'
        }).then(function (response) {
          if (response.ok) storeHealthQueue(healthQueue().filter(function (entry) {
            return entry.receipt.attemptId + ':' + entry.receipt.stage !== key;
          }));
        }).catch(function () {
          // Retain the anonymous receipt for retry on the next page/online event.
        }).finally(function () { delete healthSending[key]; });
      });
    }

    function recordHealth(stage) {
      if (preview || !pendingRequest || !/^[a-z0-9-]{20,64}$/.test(pendingRequest)) return;
      var receipt = { attemptId: pendingRequest, experimentId: experimentId,
        variant: analyticsAllowed() && !suppressSignupMeasurement ? variant : 'unknown', stage: stage };
      var queue = healthQueue();
      if (!queue.some(function (entry) { return entry.receipt.attemptId === pendingRequest && entry.receipt.stage === stage; })) {
        queue.push({ receipt: receipt, time: Date.now() });
        storeHealthQueue(queue);
      }
      flushHealth();
    }

    function publishSubmissionEvent(name) {
      if (preview || !enroll() || !pendingRequest || suppressSignupMeasurement) return;
      try {
        if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          Promise.resolve(window.Shopify.analytics.publish(name, { experiment_id: experimentId, variant_id: variant,
            event_id: pendingRequest + ':' + name, signup_status: name === 'kg_popup_attempt' ? 'attempted' : 'failed' })).catch(function () {});
        }
      } catch (error) {}
    }

    function beginAttempt() {
      if (preview || completed || busy || !email.checkValidity() || attemptRecorded) return;
      attemptRecorded = true;
      prepareSubmission();
      recordHealth('attempt');
      publishSubmissionEvent('kg_popup_attempt');
    }

    async function publishEvent(eventName) {
      if (!enroll() || listenerController.signal.aborted) return false;
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
      var payload = {
        experiment_id: experimentId,
        variant_id: variant,
        event_id: state.visitor + ':' + eventName
      };
      if (eventName === 'kg_popup_signup') payload.signup_status = 'accepted';
      var publishTimeout;
      try {
        var acceptedByBus = await Promise.race([
          Promise.resolve(window.Shopify.analytics.publish(eventName, payload)),
          new Promise(function (resolve) { publishTimeout = window.setTimeout(function () { resolve(false); }, 5000); })
        ]);
        if (acceptedByBus !== true) return false;
        var measurementId = root.dataset.ga4MeasurementId || '';
        if (analyticsAllowed() && /^G-[A-Z0-9]+$/.test(measurementId) && typeof window.gtag === 'function') {
          try { window.gtag('event', eventName, Object.assign({ send_to: measurementId }, payload)); } catch (error) {}
        }
        return true;
      } catch (error) {
        return false;
      } finally {
        window.clearTimeout(publishTimeout);
      }
    }

    async function flushMeasurements() {
      if (publishing || !enroll() || listenerController.signal.aborted || document.visibilityState === 'hidden') return;
      if (recoveredSubmission && completed) {
        if (!suppressSignupMeasurement && recoveredSubmission.variant === variant) {
          save({ viewPending: !state.viewPublished, signupPending: !state.signupPublished, done: true, t: Date.now() });
        }
        recoveredSubmission = null;
      }
      publishing = true;
      var retry = false;
      try {
        if (state.viewPending && !state.viewPublished) {
          if (await publishEvent('kg_popup_view')) save({ viewPublished: true, viewPending: false });
          else retry = true;
        }
        if (state.signupPending && !state.signupPublished && state.viewPublished && analyticsAllowed()) {
          if (await publishEvent('kg_popup_signup')) save({ signupPublished: true, signupPending: false });
          else retry = true;
        }
      } finally {
        publishing = false;
        if (retry && retryCount < 20 && analyticsAllowed() && !listenerController.signal.aborted) {
          retryCount += 1;
          retryTimer = window.setTimeout(flushMeasurements, 500);
        }
      }
    }

    function retryMeasurements() {
      window.clearTimeout(retryTimer);
      retryCount = 0;
      flushMeasurements();
    }

    function expose() {
      if (suppressSignupMeasurement || document.visibilityState === 'hidden' || !enroll()) return;
      if (!state.viewPublished) save({ viewPending: true });
      retryMeasurements();
    }

    function show(stepName) {
      steps.forEach(function (step) { step.hidden = step.dataset.step !== stepName; });
      var step = root.querySelector('[data-step="' + stepName + '"]');
      var heading = step.querySelector('.kg-takeover__heading');
      root.setAttribute('aria-labelledby', heading.id);
      if (root.hasAttribute('data-open')) heading.focus({ preventScroll: true });
    }

    function open() {
      if (challengePage) return;
      window.clearTimeout(timer);
      timer = null;
      if (!root.hasAttribute('data-open')) {
        previousFocus = document.activeElement;
        previousOverflow = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        root.setAttribute('data-open', '');
        privacyAttempts = 0;
        checkPrivacyReady();
      }
      show(completed ? 'success' : busy ? 'email' : 'choices');
    }

    function close(markSeen) {
      if (!root.hasAttribute('data-open')) return;
      root.removeAttribute('data-open');
      document.documentElement.style.overflow = previousOverflow.html;
      document.body.style.overflow = previousOverflow.body;
      if (markSeen && !preview) {
        save({ t: Date.now() });
        writeState('kg-takeover', Object.assign({}, legacy, { t: Date.now() }));
      }
      if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true });
      }
    }

    function setBusy(value) {
      busy = value;
      submit.disabled = value;
      email.readOnly = value;
      form.setAttribute('aria-busy', String(value));
      submit.textContent = value ? root.dataset.waitingMessage : originalSubmitLabel;
      statusEl.hidden = !value;
      statusEl.textContent = value ? root.dataset.waitingMessage : '';
      root.querySelector('.kg-takeover__back').disabled = value;
    }

    function showError(message, challenge) {
      errorEl.textContent = message || root.dataset.requestError;
      errorEl.style.display = 'block';
      challengeButton.hidden = !challenge;
      email.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
      challengeButton.hidden = true;
      email.removeAttribute('aria-invalid');
    }

    function accepted() {
      clearError();
      if (attemptRecorded) recordHealth('accepted');
      pending(null);
      if (!preview) {
        if (!suppressSignupMeasurement && enroll() && (!submissionVariant || submissionVariant === variant)) {
          if (!state.viewPublished) save({ viewPending: true });
          if (!state.signupPublished) save({ signupPending: true });
        }
        save({ done: true, t: Date.now() });
        writeState('kg-takeover', { t: Date.now(), done: true });
        if (tab) tab.hidden = false;
      }
      completed = true;
      if (!preview) retryMeasurements();
      root.querySelector('.kg-takeover__preview-note').hidden = !preview;
      show('success');
    }

    function prepareSubmission() {
      if (!pendingRequest) pendingRequest = token();
      var tags = ['newsletter', 'kg-takeover'];
      if (experimentEnabled) tags.push('kg-exp-' + experimentId, 'kg-variant-' + variant);
      if (choice) tags.push('kg-' + choice);
      if (!preview) tags.push('kg-attempt-' + pendingRequest);
      tagsInput.value = tags.join(',');
      submissionVariant = variant;
      // Keep Shopify's default success redirect. Overriding return_to removes
      // its accepted-state marker even when the customer was subscribed.
      var measured = enrolled && analyticsAllowed();
      var recovery = { id: pendingRequest, choice: choice, time: Date.now(), measured: measured, attempted: attemptRecorded };
      if (measured) recovery.variant = variant;
      pending(recovery);
    }

    function simulatePreview() {
      if (!preview || completed) return;
      clearError();
      email.value = email.value.trim();
      if (!email.checkValidity()) {
        showError(root.dataset.emailError, false);
        email.focus();
        return;
      }
      accepted();
    }

    if (preview) {
      submit.addEventListener('click', function (event) {
        event.preventDefault();
        simulatePreview();
      }, listenerOptions);
      email.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          simulatePreview();
        }
      }, listenerOptions);
    }

    email.addEventListener('input', function () {
      if (!preview && !busy) prepareSubmission();
    }, listenerOptions);
    submit.addEventListener('pointerdown', function () {
      if (!preview && !busy) prepareSubmission();
    }, { capture: true, signal: listenerController.signal });
    // Capture the user's actual intent before Shopify's CAPTCHA can call native
    // form.submit(), which bypasses submit listeners. Typing/choosing is not an attempt.
    submit.addEventListener('click', beginAttempt, { capture: true, signal: listenerController.signal });
    email.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.isComposing) beginAttempt();
    }, { capture: true, signal: listenerController.signal });

    form.addEventListener('submit', function (event) {
      if (completed) {
        event.preventDefault();
        return;
      }
      clearError();
      email.value = email.value.trim();
      if (!email.checkValidity()) {
        event.preventDefault();
        showError(root.dataset.emailError, false);
        email.focus();
        return;
      }
      if (preview) {
        event.preventDefault();
        simulatePreview();
        return;
      }
      prepareSubmission();
      beginAttempt();
      // Shopify owns the native submit and CAPTCHA lifecycle. A simultaneous
      // fetch can consume its one-time challenge token before verification.
      // Resume only from Shopify's accepted form marker after the redirect.
    }, listenerOptions);

    challengeButton.addEventListener('click', function () {
      if (preview || busy) return;
      prepareSubmission();
      form.requestSubmit();
    }, listenerOptions);

    function selectChoice(button) {
      choice = button.dataset.choice || '';
      cta.setAttribute('href', button.dataset.successLink || defaultCta.href);
      cta.textContent = button.dataset.successLabel || defaultCta.label;
      if (!preview) prepareSubmission();
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('.kg-takeover__close, .kg-takeover__dismiss')) close(true);
      if (event.target.closest('.kg-takeover__back') && !busy) show('choices');
      var button = event.target.closest('.kg-takeover__choice');
      if (button && !busy) {
        selectChoice(button);
        show('email');
        email.focus({ preventScroll: true });
      }
    }, listenerOptions);

    document.addEventListener('keydown', function (event) {
      if (!root.hasAttribute('data-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      }
      if (event.key === 'Tab') {
        var focusable = Array.from(root.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex="0"]'))
          .filter(function (element) { return !element.closest('[hidden]') && element.getClientRects().length > 0; });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var index = focusable.indexOf(document.activeElement);
        if (event.shiftKey && (index <= 0)) {
          event.preventDefault();
          (last || root).focus();
        } else if (!event.shiftKey && (index === -1 || document.activeElement === last)) {
          event.preventDefault();
          (first || root).focus();
        }
      }
    }, listenerOptions);

    document.addEventListener('focusin', function (event) {
      if (root.hasAttribute('data-open') && !root.contains(event.target)) root.focus({ preventScroll: true });
    }, listenerOptions);

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href$="#kg-takeover"], [data-kg-takeover-open]');
      if (trigger) {
        event.preventDefault();
        open();
      }
    }, listenerOptions);

    if (tab) {
      tab.addEventListener('click', open, listenerOptions);
      tab.hidden = challengePage;
    }

    var resumed = null;
    var returnedToPopup = window.location.hash === '#' + form.id;
    // Shopify's challenge keeps the form hash while it is still in progress.
    // Leave its CAPTCHA visible and preserve the original recovery receipt.
    if (!preview && !challengePage && (returnedToPopup || params.has('kg_popup_result'))) {
      try { resumed = JSON.parse(window.sessionStorage.getItem(pendingKey)); } catch (error) {}
      if (resumed && (!params.has('kg_popup_result') || resumed.id === params.get('kg_popup_result')) && Date.now() - resumed.time < 3600000 &&
          (!resumed.measured || variants.indexOf(resumed.variant) >= 0)) {
        suppressSignupMeasurement = !resumed.measured;
        pendingRequest = resumed.id;
        attemptRecorded = resumed.attempted === true;
        if (resumed.measured) {
          recoveredSubmission = resumed;
          variant = resumed.variant;
          submissionVariant = variant;
          applyVariant();
        }
        var resumedChoice = Array.from(root.querySelectorAll('[data-choice]')).find(function (button) {
          return button.dataset.choice === resumed.choice;
        });
        if (resumedChoice) selectChoice(resumedChoice);
        if (resultMarker && resultMarker.dataset.kgFormResult === 'accepted') {
          open();
          accepted();
        } else {
          if (attemptRecorded && resultMarker && resultMarker.dataset.kgFormResult === 'error') {
            recordHealth('failure');
            publishSubmissionEvent('kg_popup_failure');
          }
          attemptRecorded = false;
          pendingRequest = null;
          open();
          show('email');
          showError(root.dataset.requestError, false);
        }
      } else {
        resumed = null;
      }
    }
    submit.disabled = false;
    var latestSeen = Math.max(Number(state.t) || 0, Number(legacy.t) || 0);
    var due = !state.done && !legacy.done && (!latestSeen || Date.now() - latestSeen > frequency);
    var suppressed = challengePage || window.location.pathname.indexOf('/pages/offices') === 0;
    if (params.has('kg_popup_preview')) open();
    else if (!resumed && !designMode && !suppressed && (preview || due)) timer = window.setTimeout(open, delay);

    checkPrivacyReady();
    flushHealth();
    window.addEventListener('online', flushHealth, listenerOptions);
    window.addEventListener('pageshow', flushHealth, listenerOptions);
    document.addEventListener('visitorConsentCollected', function () {
      if (!preview && choice && !busy && !completed) prepareSubmission();
      if (!analyticsAllowed()) {
        window.clearTimeout(retryTimer);
        return;
      }
      if (root.hasAttribute('data-open') && !completed) expose();
      else retryMeasurements();
    }, listenerOptions);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') window.clearTimeout(retryTimer);
      else if (root.hasAttribute('data-open') && !completed) expose();
      else retryMeasurements();
    }, listenerOptions);

    document.addEventListener('shopify:section:select', function (event) {
      if (event.target.contains(root)) open();
    }, listenerOptions);
    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.target.contains(root)) close(false);
    }, listenerOptions);
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      close(false);
      window.clearTimeout(timer);
      window.clearTimeout(retryTimer);
      window.clearTimeout(privacyTimer);
      if (controller) controller.abort();
      listenerController.abort();
    }, listenerOptions);
  }

  function init(scope) {
    scope.querySelectorAll('[data-kg-takeover]').forEach(initialize);
  }
  window.KgTakeover = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
